import React, { memo } from 'react'

import Header from '~/components/Header'
import NavOptions from '~/components/NavOptions/index'
import Footer from '~/components/Footer'

import { Container } from './styles'

const DefaultLayout = memo(({ children, userData }) => (
    <Container>
        <Header usuario={userData} />

        <NavOptions />

        {children}

        <Footer />
    </Container>
))

export default DefaultLayout
